module.exports = __webpack_public_path__ + "1d68b2c2d6948eb677e4982e5797ce3b.png";